import {
    AfterViewInit,
    Component,
    Input, OnInit
} from '@angular/core';
import { ResumeUpdaterService } from '../../../cart/services/cart-resume-updater.service';
import { CartRowsUpdaterService } from '../../../cart/services/cart-rows-updater.service';
import { CartItem } from '../abstract-item-row/abstract-item-row';

@Component({
    selector: 'google-conversion-tag',
    templateUrl: './google-conversion-tag.component.html'
})
export class GoogleConversionTagComponent implements AfterViewInit, OnInit {
    @Input('googleConversionId') public googleConversionId;
    @Input('pageType') public pageType;
    @Input('offer') public offer;

    public params: {
        ecomm_prodid: Array<any>,
        ecomm_pagetype: string,
        ecomm_totalvalue: number,
    };

    protected paid = false;

    constructor(
        protected cartRowsUpdaterService: CartRowsUpdaterService,
        protected resumeUpdaterService: ResumeUpdaterService
    ) {
        this.params = {
            ecomm_totalvalue: 0,
            ecomm_pagetype: this.pageType,
            ecomm_prodid: []
        };

        this.cartRowsUpdaterService.indexed$
            .subscribe((items: Array<CartItem>) => {
                this.params.ecomm_prodid = [];
                for (let item of items) {
                    this.params.ecomm_prodid.push(item.id);
                }
            });
        this.resumeUpdaterService.indexed$.subscribe((index: any) => {
            this.params.ecomm_totalvalue = index.total;
        });
    }

    ngAfterViewInit() {
        this.params.ecomm_pagetype = this.pageType;
        this.fillPurchaseData();
        this.indexData();
    }
    ngOnInit() {
        this.params.ecomm_pagetype = this.pageType;
        this.fillPurchaseData();
        this.indexData();
    }

    /**
     * Index cart items and resume.
     */
    private indexData() {
        if (this.params.ecomm_pagetype !== 'purchase') {
            this.cartRowsUpdaterService.refresh();
            this.resumeUpdaterService.refresh();
        }
    }

    /**
     * Fill data for purchase pageType from payment service.
     */
    private fillPurchaseData() {
        if (this.pageType === 'purchase') {
            this.params.ecomm_totalvalue = this.offer.total;
            if (this.offer.items !== undefined) {
                for (let item of this.offer.items) {
                    this.params.ecomm_prodid.push(item.item.id);
                }
            }
            if (this.offer.plan !== undefined) {
                this.params.ecomm_prodid.push(this.offer.plan.id);
            }
            this.paid = true;
        }
    }

    /**
     * Can load scripts only when conversion id is defined AND is paid page
     * (/completed) OR has some value at total value and prodid.
     */
    public canLoadScripts() {
        return this.googleConversionId &&
            (this.paid ||
            (this.params.ecomm_totalvalue > 0 &&
            this.params.ecomm_prodid.length > 0));
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/shared/components/google-conversion-tag/google-conversion-tag.component.ts